import { pb } from '@/libs/pocketbase'
import { httpAuthAdapter, recordToUser, enrichTeamIds } from './adapters/http-auth'
import { httpUserProfileAdapter } from './adapters/http-user-profile'
import { sessionAdapter } from './adapters/session-adapter'
import { makeLoginUseCase } from './application/login'
import { makeLogoutUseCase } from './application/logout'
import { makeCompleteOnboarding } from './application/complete-onboarding'
import { makeUpdateSessionUser } from './application/update-session-user'
import { makeUpdateUserProfile } from './application/update-user-profile'

if (pb.authStore.isValid && pb.authStore.record && !sessionAdapter.get()) {
	const user = recordToUser(pb.authStore.record)
	sessionAdapter.set({ user })
	// Resolve team memberships off the user record (team_members is the source
	// of truth); patch them in once available so team-scoped views see the scope.
	enrichTeamIds(user).then(enriched => sessionAdapter.patchUser({ teamIds: enriched.teamIds }))
}

pb.afterSend = (response, data) => {
	if (response.status === 401 && sessionAdapter.get()) {
		pb.authStore.clear()
	}
	return data
}

const login = makeLoginUseCase(httpAuthAdapter, sessionAdapter)
const logout = makeLogoutUseCase(httpAuthAdapter, sessionAdapter)
const completeOnboarding = makeCompleteOnboarding(httpUserProfileAdapter, sessionAdapter)
const updateSessionUser = makeUpdateSessionUser(sessionAdapter)
const updateUserProfile = makeUpdateUserProfile(httpUserProfileAdapter, sessionAdapter)

export { login, logout, completeOnboarding, updateSessionUser, updateUserProfile }
